export default __webpack_public_path__ + "static/media/legend_postglacial_sediment_thickness.a8539bbd.png";